import React, {useMemo} from "react";
import MantineInputField from "./MantineInputField";
import MantineSelectField from "./MantineSelectField";

const CbuFields = ({
                       formField, extraFieldsNames = [], getBancos = () => {
    }
                   }) => {
    const {numeroCbu} = formField;
    const extraFieldsRender = useMemo(() => extraFieldsNames.map((field) => {
        switch (field) {
            case "titularTarjeta":
                return (
                    <MantineInputField
                        name={`infoDePago.titularTarjeta`}
                        label='Nombre del titular'
                        forceUpperCase
                        withAsterisk
                        isRequired
                    />
                );
            case "banco":
                let bancoOption = [];
                getBancos().then((res) => {
                    res.forEach((banco) => {
                        bancoOption.push({value: banco.value, label: banco.label})
                    })
                })
                return (
                    <MantineSelectField
                        name={`infoDePago.gestorCbu`}
                        label='Banco'
                        data={bancoOption}
                        withAsterisk
                        searchable
                        isRequired
                    />
                );
        }
    }), []);

    return (
        <>
            {extraFieldsRender}
            <MantineInputField
                name={`infoDePago.${numeroCbu.name}`}
                label={numeroCbu.label}
                withAsterisk
            />
        </>
    );
}

export default CbuFields;